<ul class="side-bar-container">
  <li class="nav-panel-item">
    <svg xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" height="100%" id="kpmg-logo"
      viewBox="0 0 283.4 113.8" width="100%" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M281.2,86.7h-14.7l2.4-9.7h-29.5l-2.4,9.7h-14.3v-2c0.2-1.1,0.4-2.2,0.7-3.5c2.6-10.5,9.5-20.9,21.4-20.9c4.7,0,9.4,1.8,8.8,8.3h17.6c0.7-3,1.9-8.2-1.5-13c-3.7-5.2-11.3-7.3-21.1-7.3c-7,0-17.1,1.1-25.9,6.8v-53h58.5V86.7z M246.7,100.9c-3.3,0.6-6.7,1-9.8,1c-8.4,0-14.3-3.9-14.4-13.1h27.2L246.7,100.9z M213,52.7l0,12.1c-4.1,5.6-6.6,11.8-7.8,16.7c-0.4,1.7-0.8,3.4-0.9,5.1h-8.6l7.3-34.9l-24.7,0l-22.1,34.9h-1.6V2.2H213V52.7z M180.4,86.7h-8.8l13.3-20.9L180.4,86.7z M144.9,51.7h-14.6l-10,34.9h-15.5c7.9-2.9,12.7-8.5,14.2-16.8c1.2-6.4,0.6-10.7-2-13.8c-3.9-4.7-11.8-4.3-18.8-4.3c-1.2,0-11.6,0-11.6,0V2.2h58.4V51.7z M135.5,86.7l6.2-21.9l0.2,21.9H135.5z M93,78.4L93,78.4c-0.6,0-1.2,0.1-1.8,0.1c-0.9,0-1.5,0-2.1,0l-3.7,0L87,72l0.8-3.2l2-7.4c0.9,0,1.7,0,2.5,0c1,0,2,0,2.9,0c4.9,0,8.1,0.3,9.2,1.9c0.9,1.2,0.8,3.3-0.3,6.4C102.4,75.1,100.2,77.8,93,78.4 M76.7,54.8l-0.9,3l-8.4,27.8l-0.3,1H39.6l-2.1-4.5l29.7-30.3H48.1l-23.2,25l7.5-25H18.3V2.2h58.4V54.8z M220.5,0v56.8c-2,1.6-3.7,3.2-5.2,5.1V0h-62.9v51.7h-5.2V0H84.2v51.8H79V0H16.1v59L0,112.6h14.1l7.1-23.7h2L35,112.6H52L40.7,88.9h25.8l-7.2,23.7h15.4l7.1-23.6h3.4v-0.1H90h0.4h29.1l-6.8,23.6h15.6l6.6-23.6h7l0.2,23.6h13.1l15-23.6h9.8l-5.1,23.6h15.3l5-23.6h8.9c-0.4,7.3,1.5,14,6.4,18.5c5.9,5.5,15.1,6.5,21.8,6.5c9.2,0,18.8-1.3,28.5-3.5l5.3-21.5h17.5V0H220.5z">
      </path>
    </svg>
  </li>
  <li class="nav-panel-item">
   <!--  <div class="appnametop">Spotlight</div>  -->
   <div class="appnamebottom mt-4">Spotlight</div>
  </li>
</ul>
<ul class="side-bar-container" >
  <ng-container  *ngFor='let item of navBtnItems'>
    <!-- *ngIf='!item.hidden' -->
    <li *ngIf='isCurrentMode(item.url,item)' class="nav-panel-item purple-item h5 pointer"  [ngClass]="{'active-purple': isCurrentUrl(item.url)}" routerLink='{{item.url}}'>
      <div class="font-12 font-weight-bold">{{item.title}}</div>
    </li>
  </ng-container>
  
 
</ul>
<!-- <nav-btn-panel [navBtnItems]="navBtnItems" activeItemClass="active-purple" hoverClass="purple-item"></nav-btn-panel> -->
<div style="bottom: 0px;position: fixed;">
  <ng-container *appUserRole="['Admin']">
    <ng-container *ngFor="let n of navAdminBtnItems">
      <li class="nav-panel-item purple-item h5 pointer" [ngClass]="{'active-purple': isCurrentUrl('/admin')}" routerLink='/admin'>
        <i [ngClass]="n.icon"></i>
      </li>

    </ng-container>

  
  </ng-container>


  <ul class="side-bar-container" style="margin-top: -1rem;">
    <li class="nav-panel-item purple-item h5 pointer" [ngClass]="{'active-purple': isCurrentUrl('/help')}" routerLink='/help'>
      <i class="fa fa-question-circle"></i>
    </li>
   
    <li class="nav-panel-item purple-item h5 pointer" [ngClass]="{'active-purple': isCurrentUrl('/copyrights')}"  routerLink='/copyrights'>
      <i class="fa fa-copyright"></i>
    </li>
    <li class="nav-panel-item purple-item h5 pointer" (click)="showDisclaimer()">
      <i class="fas fa-exclamation-circle"></i>
    </li>
    <li class="nav-panel-item purple-item h5 pointer">
      <i class="fas fa-sign-out-alt" (click)="logout()"></i>
    </li>
  </ul>

</div>
